import { ModuleWithProviders, NgModule } from '@angular/core';

import { TutorialTranslations } from './translations';
import { ASSETS_PROVIDER, AssetsProvider } from './tutorial-dialog.types';

@NgModule({
  imports: [],
  exports: [],
})
export class TutorialDialogModule {
  public static withProviders(
    translations: any,
    assetsProvider: AssetsProvider,
  ): ModuleWithProviders<TutorialDialogModule> {
    return {
      ngModule: TutorialDialogModule,
      providers: [
        { provide: TutorialTranslations, useValue: translations },
        { provide: ASSETS_PROVIDER, useValue: assetsProvider },
      ],
    };
  }
}

export * from './tutorial-dialog-nav/tutorial-dialog-nav.component';
export * from './tutorial-dialog.component';
export * from './tutorial-dialog.service';
